import { Button } from "antd";
import styled from "styled-components";

export const IconButton = styled(Button)`
  color: #a2aaad;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;

  &:hover {
    color: ${(props) =>
      props.color
        ? props.color
        : props.danger
        ? "var(--color-danger)"
        : "var(--color-primary)"};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
`;
